export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/product/addProductCategory',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allProductCategories']       
    })
